var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable */
/**
 * Printer Modal Component
 * QZ Tray printer configuration modal
 */
import React, { useCallback, useState, useEffect } from 'react';
// @ts-ignore
import qz from 'qz-tray';
import { List, Radio, Space, Spin, Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import { ReloadOutlined } from '@ant-design/icons';
import Modal from '@fp-suite/core-ui/src/components/Modal';
import ButtonAnt from '@fp-suite/core-ui/src/components/ButtonAnt';
import { usePrinterConnection } from '../../../hooks/packing';
import { useLocalNetworkPermission } from '../../../hooks/useLocalNetworkPermission';
import { LocalNetworkPermissionModal } from '../../LocalNetworkPermissionModal';
export var PrinterModal = function (_a) {
    var visible = _a.visible, onClose = _a.onClose;
    var t = useTranslation().t;
    var _b = usePrinterConnection(), isConnectionActive = _b.isConnectionActive, printers = _b.printers, connectPrinter = _b.connectPrinter, disconnectPrinter = _b.disconnectPrinter, findPrinters = _b.findPrinters, setActivePrinter = _b.setActivePrinter, getActivePrinter = _b.getActivePrinter;
    var handleQzRequestPermission = useCallback(function () { return __awaiter(void 0, void 0, Promise, function () {
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, connectPrinter()];
                case 1:
                    _c.sent();
                    return [2 /*return*/, !!((_b = qz === null || qz === void 0 ? void 0 : qz.websocket) === null || _b === void 0 ? void 0 : _b.isActive())];
                case 2:
                    _a = _c.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [connectPrinter]);
    var _c = useLocalNetworkPermission(handleQzRequestPermission), guardQzAction = _c.guardQzAction, qzModalVisible = _c.modalVisible, qzModalStatus = _c.modalStatus, onQzRequestPermission = _c.onRequestPermission, onQzCloseModal = _c.onCloseModal;
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(''), selectedMainPrinter = _e[0], setSelectedMainPrinter = _e[1];
    var _f = useState(''), selectedLabelPrinter = _f[0], setSelectedLabelPrinter = _f[1];
    // Load current settings
    useEffect(function () {
        if (visible) {
            var mainPrinter = getActivePrinter('main');
            var labelPrinter = getActivePrinter('label');
            if (mainPrinter)
                setSelectedMainPrinter(mainPrinter);
            if (labelPrinter)
                setSelectedLabelPrinter(labelPrinter);
        }
    }, [visible, getActivePrinter]);
    // Refresh printers
    var handleRefresh = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, findPrinters()];
                case 1:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [findPrinters]);
    // Connect/disconnect
    var handleToggleConnection = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isConnectionActive) return [3 /*break*/, 1];
                    disconnectPrinter();
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, guardQzAction(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, connectPrinter()];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, handleRefresh()];
                                case 2:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [isConnectionActive, guardQzAction, connectPrinter, disconnectPrinter, handleRefresh]);
    // Save settings
    var handleSave = useCallback(function () {
        if (selectedMainPrinter) {
            setActivePrinter('main', selectedMainPrinter);
        }
        if (selectedLabelPrinter) {
            setActivePrinter('label', selectedLabelPrinter);
        }
        onClose();
    }, [selectedMainPrinter, selectedLabelPrinter, setActivePrinter, onClose]);
    // Load printers when modal opens
    useEffect(function () {
        if (visible && isConnectionActive && printers.length === 0) {
            handleRefresh();
        }
    }, [visible, isConnectionActive]);
    return (_jsxs(_Fragment, { children: [_jsx(Modal, __assign({ title: String(t('Printer Configuration')), visible: visible, onCancel: onClose, width: '500px' }, { children: _jsxs("div", __assign({ className: 'mb-4 font-inter' }, { children: [_jsxs("div", __assign({ className: 'flex items-center justify-between mb-4 p-3 bg-gray-50 rounded' }, { children: [_jsxs("div", __assign({ className: 'flex items-center gap-2' }, { children: [_jsx("span", { className: "w-3 h-3 rounded-full " + (isConnectionActive ? 'bg-green-500' : 'bg-red-500') }, void 0), _jsx("span", { children: isConnectionActive ? t('Connected to QZ Tray') : t('Disconnected from QZ Tray') }, void 0)] }), void 0), _jsxs(Space, { children: [_jsx(ButtonAnt, { size: 'small', className: "font-normal text-sm " + (isConnectionActive ? 'bg-red-500' : 'bg-green-500'), buttonText: isConnectionActive ? String(t('Disconnect')) : String(t('Connect')), onClick: handleToggleConnection }, void 0), isConnectionActive && (_jsx(ButtonAnt, { size: 'small', className: 'font-normal text-sm', buttonText: String(t('Refresh')), onClick: handleRefresh, icon: _jsx(ReloadOutlined, {}, void 0) }, void 0))] }, void 0)] }), void 0), loading ? (_jsx("div", __assign({ className: 'flex justify-center py-8' }, { children: _jsx(Spin, {}, void 0) }), void 0)) : !isConnectionActive ? (_jsx(Empty, { description: t('Connect to QZ Tray to see available printers') }, void 0)) : printers.length === 0 ? (_jsx(Empty, { description: t('No printers found') }, void 0)) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: 'mb-4' }, { children: [_jsx("h4", __assign({ className: 'font-medium mb-2' }, { children: t('Main Printer (Packing Slips)') }), void 0), _jsx(Radio.Group, __assign({ value: selectedMainPrinter, onChange: function (e) { return setSelectedMainPrinter(e.target.value); }, className: 'w-full' }, { children: _jsx(List, { size: 'small', dataSource: printers, renderItem: function (printer) { return (_jsx(List.Item, __assign({ className: 'hover:bg-gray-50 cursor-pointer' }, { children: _jsx(Radio, __assign({ value: printer, className: 'w-full' }, { children: _jsx("span", __assign({ className: 'ml-2' }, { children: printer }), void 0) }), void 0) }), void 0)); } }, void 0) }), void 0)] }), void 0), _jsxs("div", { children: [_jsx("h4", __assign({ className: 'font-medium mb-2' }, { children: t('Label Printer (Shipping Labels)') }), void 0), _jsx(Radio.Group, __assign({ value: selectedLabelPrinter, onChange: function (e) { return setSelectedLabelPrinter(e.target.value); }, className: 'w-full' }, { children: _jsx(List, { size: 'small', dataSource: printers, renderItem: function (printer) { return (_jsx(List.Item, __assign({ className: 'hover:bg-gray-50 cursor-pointer' }, { children: _jsx(Radio, __assign({ value: printer, className: 'w-full' }, { children: _jsx("span", __assign({ className: 'ml-2' }, { children: printer }), void 0) }), void 0) }), void 0)); } }, void 0) }), void 0)] }, void 0)] }, void 0)), _jsxs("div", __assign({ className: 'flex justify-end gap-2 mt-4' }, { children: [_jsx(ButtonAnt, { buttonText: String(t('Cancel')), onClick: onClose }, void 0), _jsx(ButtonAnt, { buttonText: String(t('Save')), type: 'primary', onClick: handleSave }, void 0)] }), void 0)] }), void 0) }), void 0), _jsx(LocalNetworkPermissionModal, { visible: qzModalVisible, status: qzModalStatus, onClose: onQzCloseModal, onRequestPermission: onQzRequestPermission }, void 0)] }, void 0));
};
export default PrinterModal;
